import styled from '@emotion/styled';

export const ConnectionTag = styled.div<{ color: 'blue' | 'lightBlue' | 'medium' }>`
  background: ${(props) =>
    props.color === 'lightBlue'
      ? props.theme.color.blue.lightBlue
      : props.theme.color[props.color].default};
  color: ${(props) =>
    props.color === 'lightBlue' ? props.theme.color.blue.default : props.theme.color.light.default};
  padding: 5px 15px;
  font-size: 13px;
  border-radius: 10px;
  font-weight: 700;

  width: fit-content;

  margin: auto;
  margin-bottom: 15px;
`;
